import users from './users';
import { exams, admin_exams } from './exams';
import admin from './admin';

const menuItems = {
  items: [users, exams, admin_exams, admin]
};

export default menuItems;
